import { Notifications, InsertChart, Apps, Home, Person, AssignmentInd, Password, Security } from '@mui/icons-material'
import * as Yup from 'yup'

import { Errors } from '@tabeeb/shared/forms'
import { addQueriesToUrl } from '@tabeeb/shared/utils/helpers'
import domainService from '@tabeeb/services/domainService'
import { CertificatesIcon, QualificationsIcon } from '@tabeeb/shared/icons'

export const UserSettingsTabs = {
  ProfileDetails: 'profile-details',
  Address: 'address',
  Notifications: 'notifications',
  HealthData: 'health-data',
  Certificates: 'certificates',
  Qualifications: 'qualifications',
  MyAccount: 'my-account',
  ChangePassword: 'change-password',
  MultiFactorAuthentication: 'mfa',
  MyTenants: 'my-tenants',
}

export const getTabs = ({ showHealthData, showCertificates, showQualifications }) => [
  { id: UserSettingsTabs.ProfileDetails, label: 'Profile details', icon: <Person />, toDisplay: true },
  { id: UserSettingsTabs.Address, label: 'Address', icon: <Home />, toDisplay: true },
  { id: UserSettingsTabs.Notifications, label: 'Notifications', icon: <Notifications />, toDisplay: true },
  { id: UserSettingsTabs.HealthData, label: 'Health data', icon: <InsertChart />, toDisplay: showHealthData },
  { id: UserSettingsTabs.Certificates, label: 'Certificates', icon: <CertificatesIcon />, toDisplay: showCertificates },
  {
    id: UserSettingsTabs.Qualifications,
    label: 'Qualifications',
    icon: <QualificationsIcon />,
    toDisplay: showQualifications,
  },
  {
    id: UserSettingsTabs.MyAccount,
    label: 'My account',
    url: `${process.env.TABEEB_IDENTITY_URL}/Manage`,
    icon: <AssignmentInd />,
    toDisplay: true,
    displayDividerBefore: true,
  },
  {
    id: UserSettingsTabs.ChangePassword,
    label: 'Change password',
    url: `${process.env.TABEEB_IDENTITY_URL}/Manage/ChangePassword`,
    icon: <Password />,
    toDisplay: true,
  },
  {
    id: UserSettingsTabs.MultiFactorAuthentication,
    label: 'Multi-factor Authentication',
    url: `${process.env.TABEEB_IDENTITY_URL}/Manage/TwoFactorAuthentication`,
    icon: <Security />,
    toDisplay: true,
  },
  {
    id: UserSettingsTabs.MyTenants,
    label: 'My tenants',
    url: `${process.env.TABEEB_IDENTITY_URL}/Manage/Tenants`,
    icon: <Apps />,
    toDisplay: true,
  },
]

export const getSetupMfaISUrl = async () => {
  const setupMfaPathNameAndSearch = addQueriesToUrl(
    [
      {
        key: 'returnUrl',
        value: domainService.createOriginWithSubdomain(`${domainService.subdomain}.`),
      },
    ],
    '/Manage/TwoFactorAuthentication'
  )

  return `${process.env.TABEEB_IDENTITY_URL}${setupMfaPathNameAndSearch.pathname}?${setupMfaPathNameAndSearch.search}`
}

export const loginInitialValues = {
  Username: '',
  Password: '',
}

export const loginSchema = Yup.object().shape({
  Username: Yup.string().required(Errors.empty),
  Password: Yup.string().required(Errors.empty),
})

export const registerSchema = Yup.object().shape({
  FirstName: Yup.string().trim().max(35, 'Maximum length is 35 characters').required('Required'),
  LastName: Yup.string().trim().max(35, 'Maximum length is 35 characters').required('Required'),
})
